import { FC } from "react";

const NotFound: FC = () => {
  return (
    <div className="hero min-h-screen">
      <div className="hero-content text-center">
        <div className="max-w-md">
          <h1 className="text-5xl font-bold">
            Page not found
          </h1>
        </div>
      </div>
    </div>
  );
};

export default NotFound;